import { TriangleUpIcon } from '@radix-ui/react-icons';
import { Badge, Skeleton } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { PlainRank } from 'api/generated';
import { getColorFromRanks } from 'helpers/ranks';

export const RankLabel: React.FC<{
  rank?: PlainRank;
  simulated_rank_higher?: boolean;
  linkTo?: boolean;
  isSuperSimulation?: boolean;
  className?: string;
  loading?: boolean;
  stretch?: boolean;
}> = ({ rank, simulated_rank_higher, linkTo, isSuperSimulation, className, loading = false, stretch = false }) => {
  if (!rank || loading) return <Skeleton className='h-6 w-10' />;
  const backgroundColor = getColorFromRanks(rank);
  const style = isSuperSimulation
    ? {
        backgroundColor: 'rgb(91 91 214 / var(--tw-bg-opacity))',
        color: 'white',
        border: '2px solid white',
      }
    : {
        alignItems: 'center',
      };

  const badgeClassName = classNames(
    'rounded-sm',
    'text-neutral-neutral-1',
    'border',
    'border-solid',
    'border-neutral-neutral-alpha-7',
    'justify-center',
    'gap-0',
    { 'min-w-0': stretch },
    { 'min-w-11': !stretch },
    { 'pr-0': simulated_rank_higher },
    className,
    backgroundColor,
  );

  const span = (
    <Badge style={style} className={badgeClassName}>
      {rank}
      {simulated_rank_higher && <TriangleUpIcon />}
    </Badge>
  );
  return linkTo ? (
    <Link
      to={{
        pathname: '/classifiche',
        search: `?rank=${rank}`,
      }}
    >
      {span}
    </Link>
  ) : (
    span
  );
};

export default RankLabel;
